export default __webpack_public_path__ + "static/media/Meal_Clock.ccd3767b.svg";